import { useSelector } from "react-redux";
import { Button, DraggableCarousel } from "../../../components/ui";
import localization from "../../../config/localization";
import { selectInboxUnreadCount } from "../selectors/userProfileSelectors";
import userDeviceStore from "../../../store/device.store";
import { DeviceType } from "../../../models/constants/deviceType";

interface UserTabsProps {
  activeTab: string;
  onTabChange: (tab: string) => void;
}

export function UserTabs({ activeTab, onTabChange }: UserTabsProps) {
  const tabs = [
    {
      id: "profile",
      label: localization.profile,
      icon: "/icons/ic-profile.svg",
    },
    {
      id: "deposit",
      label: localization.deposit,
      icon: "/icons/ic-deposit.svg",
    },
    {
      id: "withdrawal",
      label: localization.withdraw,
      icon: "/icons/ic-withdraw.svg",
    },
    {
      id: "wallethistory",
      label: localization.wallet,
      icon: "/icons/ic-wallet.svg",
    },
    {
      id: "transactions",
      label: localization.transactions,
      icon: "/icons/ic-transaction.svg",
    },
    { id: "bonus", label: localization.bonus, icon: "/icons/ic-bonus.svg" },
    {
      id: "inbox",
      label: localization.inbox,
      icon: "/icons/ic-inbox.svg",
      badge: useSelector(selectInboxUnreadCount),
    },
    {
      id: "verification",
      label: localization.verification,
      icon: "/icons/ic-verification.svg",
    },
    {
      id: "responsible-gaming",
      label: localization["responsible-gaming"],
      icon: "/icons/ic-responsible-gaming.svg",
    },
  ];

  const deviceType = userDeviceStore((state) => state.deviceType);


  return (
    <div
      className={`w-full top-20 -mt-3 sticky backdrop-blur-[44px] shadow-lg z-30 bg-[#0808081A] ${deviceType === DeviceType.Mobile ? "px-4" : "max-w-[95%] mx-auto"}`}
      id="user-tabs"
    >
      <div className="pt-3 relative">
        {deviceType === DeviceType.Web && <div className="absolute bottom-0 left-0 right-0 w-full h-[2px] bg-gradient-to-r from-transparent via-[#353535] to-[#353535]"></div>}
        <DraggableCarousel
          gap="gap-3"
          className="w-full"
          activeIndex={tabs.findIndex((tab) => tab.id === activeTab)}
          itemClassName="justify-evenly"
        >
          {tabs.map((tab) => {
            const isActive = activeTab === tab.id;

            return (
              <Button
                key={tab.id}
                onClick={() => onTabChange(tab.id)}
                className={`
                relative
                flex items-center justify-center gap-1
                h-12 p-3
                font-medium text-sm whitespace-nowrap
                transition-all duration-200

                ${isActive
                    ? "bg-[linear-gradient(180deg,rgba(255,148,177,0)_0%,rgba(255,148,177,0.2)_84.62%)]"
                    : "bg-transparent hover:bg-white/5"
                  }
              `}
              >
                <span
                  className={`
                  flex items-center justify-center
                  w-9 h-9 rounded-full
                  ${isActive
                      ? "border border-[#6B1E33] bg-[#222222]"
                      : "border border-transparent"
                    }
                `}
                >
                  <div className="relative w-10 h-10">
                    <img
                      src={tab.icon}
                      alt={tab.label}
                      className="w-10 h-10 object-contain"
                    />

                    {tab.id === "inbox" &&
                      tab.badge !== undefined &&
                      tab.badge > 0 && (
                        <span
                          className="absolute top-1 -right-1 bg-red-500 text-white text-xs font-semibold 
    w-5 h-5 rounded-full flex items-center justify-center
    border-2 border-[#1a0f14]"
                        >
                          {tab.badge > 9 ? "9+" : tab.badge}
                        </span>
                      )}
                  </div>
                </span>

                <span
                  className={`${isActive ? "text-white" : "text-white/70"} lg:text-base`}
                >
                  {tab.label}
                </span>

                <span
                  className={`
                    absolute bottom-0 left-0 right-0 h-px
                     ${isActive ? "bg-[linear-gradient(90deg,#353535_0%,#FFFFFF_49.4%,#353535_100%)]" : ""}
                  `}
                />
              </Button>
            );
          })}
        </DraggableCarousel>
      </div>
    </div >
  );
}
